// Shared by the client bundle, the Express server and the webpack source map upload.
// `datadogService` must match the `service` used when uploading source maps, otherwise
// Error Tracking cannot de-minify stack traces.
const datadogSite = 'datadoghq.eu';
const datadogService = '10bis-next';

module.exports = {datadogSite, datadogService};
